import React, { useState } from 'react';
import { Caption, Text } from 'ui';
import { useTranslation } from 'react-i18next';
import { Modal } from 'components';
import { KoobButton, KoobInputSelect } from '@koob/ui';
import Avatar from 'components/Avatar';
import { useApp } from '../../../../hooks';
import { useAsync } from 'react-async';
import { getOrganization } from 'api/node/organization';
import { Stack } from '@koob/margaret';
import { formatCurrencyLabel, formatImageLinkForCss } from 'utils';
import TosMaximumTimeBeforeBooking from 'components/TosMaximumTimeBeforeBooking/TosMaximumTimeBeforeBooking';
import ExchangeRatesForm from './ExchangeRatesForm';
import { RoleEnum } from '@koob/enums';

export default function Header({
  isAllowedToManage,
  organizations,
  selectedOrganization,
  onOrganizationChange,
}) {
  const { currentUserRole } = useApp();
  const { t } = useTranslation('toConnectionRequest');
  const [isCurrencyExchangeModalOpened, setIsCurrencyExchangeModalOpened] =
    useState(false);

  const { data } = useAsync({
    promiseFn: getOrganization,
    id: Number(selectedOrganization?.value),
  });
  const currentOrganization = data?.data;

  return (
    <div className="bg-white border p-10">
      <Stack
        direction="row"
        alignY="center"
        alignX="space-between"
        gutterSize={2}
      >
        <Stack direction="column" gutterSize={0.5}>
          <Stack direction="row" gutterSize={0.5} alignY="center">
            <Stack direction="column" gutterSize={0.5}>
              <Avatar
                imageUrl={formatImageLinkForCss(currentOrganization?.avatarUrl)}
              />
            </Stack>
            <Stack direction="column" gutterSize={2} alignY="center">
              <Stack>
                {currentUserRole === RoleEnum.KOOB_ADMIN ? (
                  <KoobInputSelect
                    searchable
                    options={
                      organizations?.length
                        ? organizations
                        : [selectedOrganization]
                    }
                    value={selectedOrganization?.value}
                    onValueChange={(value) =>
                      onOrganizationChange(
                        organizations.find((o) => o.value === value),
                      )
                    }
                    placeholder={t('searchOrganization')}
                    style={{ minWidth: 320 }}
                  />
                ) : (
                  <Text type="h1">{currentOrganization?.name}</Text>
                )}
              </Stack>
            </Stack>
          </Stack>
        </Stack>
        <Stack direction="column" gutterSize={2}>
          <Stack
            direction="row"
            gutterSize={0.5}
            alignX="flex-end"
            alignY="center"
          >
            <Caption>
              <div>
                {selectedOrganization?.currency &&
                  t('defaultCurrency', {
                    currency: formatCurrencyLabel(
                      selectedOrganization?.currency,
                    ),
                  })}
              </div>
            </Caption>
            <KoobButton
              onClick={() => setIsCurrencyExchangeModalOpened(true)}
              variant="secondary"
            >
              <i className="fa-regular fa-gear" />
              {t('exchangeRates')}
            </KoobButton>
          </Stack>
        </Stack>
      </Stack>

      <Stack direction="row" marginTop={1.5} gutterSize={1.5} alignX="center">
        <TosMaximumTimeBeforeBooking
          isAllowedToManage={isAllowedToManage}
          organizationId={Number(selectedOrganization?.value)}
        />
      </Stack>

      {isCurrencyExchangeModalOpened && (
        <Modal
          isOpen
          onRequestClose={() => {
            setIsCurrencyExchangeModalOpened(false);
          }}
          title={
            <Stack size="full" alignY="center" gutterSize={1}>
              <p>{t('currencyExchangeRateModal:title')}</p>
            </Stack>
          }
          size={'large'}
        >
          <ExchangeRatesForm
            dmcCurrency={currentOrganization?.currency}
            isAllowedToManage={isAllowedToManage}
            organizationId={selectedOrganization?.value}
          />
        </Modal>
      )}
    </div>
  );
}
